import { gql } from 'apollo-angular'

export const ORGANIZATION_FIELDS = gql`
  fragment OrganizationFields on Organization {
    id
    dh_id
    name
    branch
    streetName
    streetNumber
    postalCode
    city
    country
    state
    phone
    vatNumber
    tax_exemption
    tax_reverse_charge
    function
    webLinkedin
    webLink
    seatsEnabled
    createdAt
    updatedAt
    invoiceAddressee
    invoiceEmail
  }
`
